export const CHANGELOG_TYPE_BUGFIX = 'bugfix';
export const CHANGELOG_TYPE_FEATURE = 'feature';
export const CHANGELOG_TYPE_IMPROVEMENT = 'improvement';

const ChangeLog = [
  {
    date: "2018-10-25",
    type: CHANGELOG_TYPE_BUGFIX,
    title: "Historia zmian - Kopiowanie danych z grupy.",
    description: [
      "Z powodu pewnego błędu niedziałało podglądanie historii zmian dokonanej przez akcję `kopiowania danych z grupy`.",
      "Problem został rozwiązany. Dodatkowo, nowe, nieznane typy zmian będą teraz otwierane w poglądzie JSON zamiast powodować błąd i crashując stronę."
    ],
    permissionsAffected: [
      "/controllers/EventLogs/index",
    ]
  },
  {
    date: "2018-10-25",
    type: CHANGELOG_TYPE_FEATURE,
    title: "Słowa kluczowe na liście produktów.",
    description: [
      "Do każdego produktu na liście produktów została dodana informacja o słowach kluczowych.",
      "Informacja znajduje się pod listą kategorii.",
      "Kliknięcie na słowo kluczowe spowoduje jego skopiowanie."
    ],
    permissionsAffected: [
      "/controllers/Products/index",
    ]
  },
  {
    date: "2018-11-13",
    type: CHANGELOG_TYPE_FEATURE,
    title: "Możliwość zaznaczenia wielu rekordów na liście zmian produktów.",
    description: [
      "Na liście zmian produktów zostały wprowadzone checkbox'y umożliwiające zaznaczenie wielu rekordów oraz możliwość wyświetlenia listy produktów zaznaczonych zmian."
    ],
    permissionsAffected: [
      "/controllers/Products/index",
    ]
  },
];

export default ChangeLog;



// WEBPACK FOOTER //
// ./constants/ChangeLog.js